import { mapActions } from 'vuex';

export default {
  data() {
    return {
      tab: 0,
      keys: ['pernyataan', 'pakta'],
      formulir: {},
      contents: {
        pernyataan: {
          component: 'Daftar',
          form: 'FormUnggah',
          title: 'Dokumen Kelengkapan',
          status: 'pernyataan',
          deskripsi: '',
          optional: false,
        },
        pakta: {
          component: 'Daftar',
          form: 'FormUnggah',
          title: 'Dokumen Kelengkapan',
          status: 'pernyataan',
          deskripsi: '',
          optional: false,
        },
      },
    };
  },

  computed: {
    status() {
      return {
        pernyataan: !!this.isUpload('pernyataan'),
      };
    },

    items() {
      let result = [];
      for (const key of this.keys || []) {
        if (this.contents[key] || this[key]) {
          const temp = Object.assign({ id: key }, this.contents[key] || this[key] || {});
          result.push(temp);
        }
      }

      return result;
    },

    berkas() {
      return {
        pernyataan: {
          label: 'Surat Pernyataan Dukungan Dinas Pendidikan / Atasan',
          title: 'Surat Pernyataan Dukungan Dinas Pendidikan / Atasan',
          pesan: `Pastikan Anda mengunduh
                  <a style="font-weight: bold" href="https://files1.simpkb.id/berkas/sekolah-penggerak/surat_pernyataan_atasan.docx" target="_blank">template dokumen ini</a>,
                  kemudian anda print, isi lalu anda scan, dan unggah di sini dalam format PDF`,
        },
        pakta: {
          label: 'Pakta Integritas',
          title: 'Pakta Integritas',
          pesan: `Pastikan pakta integritas yang Anda kirimkan sesuai dengan 
                  <a style="font-weight: bold" href="${process.env.VUE_APP_API_URL +
                    '/psp/gtk/peserta-ajuan/template-pakta'}" target="_blank">template dokumen ini</a>`,
        },
      };
    },
  },

  methods: {
    ...mapActions('cv', ['fetch']),

    ...mapActions('profil', {
      index: 'index',
      actions: 'actions',
    }),

    onUpload(payload) {
      if (this.isAjuan && this.kVerval !== 5) {
        const msg = `<p class="title mb-2">Mohon maaf! Data Anda telah diajukan dan dalam Proses verval, 
                    sehingga tidak dapat diubah untuk saat ini</p> 
                    Jika Anda ingin mengubah Data Anda, silakan melakukan aksi batal ajuan`;
        this.$warning(msg, `Ubah Data`);
        return;
      }

      this.$set(this.formulir, 'form', 'FormUnggah');
      this.$set(this.formulir, 'title', `${this.berkas[payload]['label']}`);
      this.$set(this.formulir, 'type', payload);
      this.$set(this.formulir, 'format', `harus bertipe PDF`);
      this.$set(this.formulir, 'rules', { format: 'PDF', required: true });
      this.$set(this.formulir, 'mode', 'upload');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'max', 1500);

      this.$set(this.formulir, 'detail', {});
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        // this.$set(this.formulir, 'init', berkas[0])
      });
    },

    uploadData() {
      const type = this.formulir.type;
      const formData = new FormData();
      formData.append('label', type);
      formData.append(type === 'pakta' ? 'file_pakta' : 'file', this.$refs.formulir.form.file);
      this.actions({
        id: this.profilID,
        action: type === 'pakta' ? 'upload-pakta' : 'berkas-izin-insert',
        params: formData,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      })
        .then(() => {
          this.$success(`Berkas berhasil diunggah`);
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    isUpload(id) {
      if (id === 'pakta') {
        return !!this.$getDeepObj(this, 'detail.meta.peserta_ajuan.url_pakta');
      }

      return (
        this.berkases.filter((item) => {
          return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === id;
        }).length > 0
      );
    },

    getBerkas(id) {
      if (id === 'pakta') {
        const ajuan = this.$getDeepObj(this, 'detail.meta.peserta_ajuan') || {};
        return ajuan.url_pakta
          ? {
              file_berkas: this.$getDeepObj(ajuan, 'file_pakta'),
              url_berkas: this.$getDeepObj(ajuan, 'url_pakta'),
            }
          : {};
      }

      const berkas = this.berkases.filter((item) => {
        return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === id;
      });

      return (berkas && berkas[0]) || {};
    },

    onReload() {
      this.index(true);
      this.fetch({ id: this.profilID, reset: true });
    },

    onAjuan() {
      this.$confirm(
        `<h3>Anda yakin ingin mengajukan Verval Berkas Surat Pernyataan Dukungan Dinas Pendidikan / Atasan sekarang?</h3>`,
        `Ajuan Verval Surat Pernyataan Dukungan Dinas Pendidikan / Atasan`,
        {
          tipe: 'success',
        }
      ).then(() => {
        this.actions({
          id: this.profilID,
          action: 'ajuan-izin',
        }).then(() => {
          this.$success(`Surat Pernyataan Dukungan Dinas Pendidikan / Atasan berhasil diajukan`);
          this.onReload();
        });
      });
    },

    onBatalAjuan() {
      this.$confirm(
        `<h3>Anda yakin ingin membatalkan pengajuan Verval Berkas Surat Pernyataan Dukungan Dinas Pendidikan / Atasan sekarang?</h3>`,
        `Batal Ajuan Verval Surat Pernyataan Dukungan Dinas Pendidikan / Atasan`,
        { tipe: 'error' }
      ).then(() => {
        this.actions({
          id: this.profilID,
          action: 'batal-ajuan-izin',
        }).then(() => {
          this.$success(`Pengajuan Surat Pernyataan Dukungan Dinas Pendidikan / Atasan berhasil dibatalkan`);
          this.onReload();
        });
      });
    },
  },
};
